<template>
  <b-modal
    id="session-map-modal"
    ref="session-map-modal"
    size="map-modal"
    centered
    hide-footer
    hide-header
    @shown="onModalShown"
    @hide="onModalHide"
  >
    <l-map
      v-if="visibleMap"
      :zoom="zoom"
      :center="center"
      :min-zoom="minZoom"
      :max-zoom="maxZoom"
      :bounds="markerBounds"
      :zoom-animation="true"
      :fade-animation="true"
      :marker-zoom-animation="true"
      :zoom-animation-threshold="10"
      class="map-wrapper"
    >
      <l-tile-layer
        :url="url"
        :attribution="attribution"
      />
      <l-marker
        v-for="(marker, idx) in filteredMarkers"
        :key="idx"
        :lat-lng="getMarkerLatLng(marker)"
        :icon="getMarkerIcon(marker)"
        @click="centerMarker(marker)"
      >
        <l-popup>
          <div
            class="header"
            :class="getStatusClass(marker.type)"
          >
            <span class="status-label">
              {{ getStatusLabel(marker.type) }}
            </span>
            <i class="atto atto-rdir-arrow-b right-arrow" />
            <span class="time">
              {{ marker.time }}
            </span>
          </div>
          <div class="details">
            <div class="content-row">
              <i
                class="atto atto-location-marker-lt"
                :class="getStatusClass(marker.type)"
              />
              <span class="address">
                {{ marker.address }}
              </span>
            </div>
            <div
              v-if="marker.accuracy"
              class="content-row column"
            >
              <span class="acc">{{ label.get('accuracy') }} · {{ marker.accuracy }}</span>
            </div>
          </div>
        </l-popup>
      </l-marker>
    </l-map>
  </b-modal>
</template>

<script>

    import TimesheetService from "./TimesheetService";

    export default {
        name: "SessionMapComponent",
        props: {
           id: {
             type: String
           }
        },
        data() {
            return {
                maxZoom: 16,
                minZoom: 5,
                zoom: 11,
                center: [0.0, 0.0],
                bounds: null,
                url: 'https://{s}-tiles.locationiq.com/v2/obk/r/{z}/{x}/{y}.png?key=pk.b79bd6c735e4ccd1a09bace11fdbd698',
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                options: {
                    animate: true,
                    pan: {
                        duration: 10
                    }
                },
                markers: [],
                visibleMap: false
            }
        },
        computed: {
            markerBounds: function () {
              return this.getBounds(this.filteredMarkers);
            },
            filteredMarkers: function () {
              return this.markers;
            }
        },
        mounted() {
          this.loadMap();
          document.body.appendChild(this.$el);
          this.$refs['session-map-modal'].show();
        },
        methods: {
            onModalShown() {
                this.visibleMap = true;
            },
            onModalHide() {
                this.$root.$emit('hideExtendedMap');
            },
            getStatusClass(status) {
                if (status === 0) {
                    return 'clockedIn';
                } else if (status === 1) {
                    return 'clockedOut';
                }
            },
            getStatusLabel(status) {
              if(status === 0) {
                return this.label.get('clocked_in')
              }
              if(status === 1) {
                return this.label.get('clocked_out')
              }
            },
            zoomUpdated(zoom) {
                this.zoom = zoom;
            },
            centerUpdated(center) {
                this.center = center;
            },
            boundsUpdated(bounds) {
                this.bounds = bounds;
            },
            getBounds(markers) {
                let _this = this;
                let bounds = new L.LatLngBounds();
                markers.forEach(function (marker) {
                    bounds.extend(_this.getMarkerLatLng(marker));
                });
                return bounds;
            },
            getMarkerLatLng(marker) {
                return L.latLng(marker.latitude, marker.longitude);
            },
            timeAgo(syncTime) {
                let diff = this.$moment().diff(this.$moment(syncTime));
                if (diff * 0.001 < 60) {
                    return 'Just Now';
                }
                return this.$moment(syncTime).startOf('minute').fromNow();
            },
            getMarkerIcon(marker) {
                if (marker.type === 0) {
                    return L.divIcon({
                        iconSize: new L.Point(60, 60),
                        html: '<span class="inner-clockin"></span>'
                    });
                } else if (marker.type === 4) {
                    return L.divIcon({
                        iconSize: new L.Point(60, 60),
                        html: '<span class="inner-break"></span>'
                    });
                } else {
                    return L.divIcon({
                        iconSize: new L.Point(60, 60),
                        html: '<span class="inner-clockout"></span>'
                    });
                }
            },
            centerMarker(marker) {
                let _this = this;
                this.centerUpdated(L.latLng(marker.latitude + 0.001, marker.longitude));
                if (this.zoom < 16) {
                    setTimeout(function () {
                        _this.zoomUpdated(16);
                    }, 300);
                }
            },
            loadMap() {
              debugger;
                TimesheetService.getTimeEntryMap(this.id).then((result) => {
                  debugger;
                  this.markers = result;
                  console.log(result);
                }).catch(error => {
                  console.log(error);
                })
            }
        }
    }
</script>

<style lang="scss">

    .modal-map-modal {
        max-width: 922px;
        width: 880px;
        max-height: 387px !important;

        .modal-body {
            padding: 21px;
            background: #fff;
        }

        .map-wrapper {
            max-width: 922px;
            width: 880px;
            height: 345px !important;
        }
    }

    .leaflet-popup {
        width: 383px;
        margin-bottom: 30px;

        .leaflet-popup-content-wrapper {
            /*min-height: 214px;*/
            box-shadow: 0 -2px 10px 0 rgba(199, 199, 199, 0.5);
            border-radius: 0;
            padding: 0;
        }

        .leaflet-popup-content {
            width: 100% !important;
            display: flex;
            flex-direction: column;
            padding: 0;
            margin: 0;

            > div {
                padding: 20px;
            }

            .header {
                display: flex;
                align-items: center;
                flex-direction: row;
                padding-bottom: 16px;
                border-bottom: 2px solid #efefef;

                span.status-label {
                    font-size: 1rem;
                    line-height: 1.25rem;
                    color: #262626;
                    font-family: 'Roboto', sans-serif;
                    font-weight: 500;
                    margin-right: 10px;
                }

                i.right-arrow {
                    font-size: 10px;
                    color: #C7C7C7;
                    margin-right: 10px;
                }

                span.time {
                    font-size: 1rem;
                    line-height: 1.5rem;
                    color: #262626;
                    font-family: 'Roboto', sans-serif;
                    font-weight: 500;
                    margin-right: 20px;
                }

                &.clockedIn {
                    span.time,
                    span.status-label {
                        color: #06B879;
                    }
                }

                &.clockedOut {
                    span.time,
                    span.status-label {
                        color: #E05656;
                    }
                }

            }

            .details {
                padding-top: 16px;
                display: flex;
                flex-direction: column;

                .content-row {
                    padding-left: 32px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    position: relative;
                    margin-bottom: 4px;

                    span.acc {
                        font-size: 0.75rem;
                        line-height: 1rem;
                        font-family: 'Roboto', sans-serif;
                        font-weight: 400;
                        color: #999;
                    }

                    span.address {
                        font-size: 0.875rem;
                        line-height: 1.25rem;
                        font-family: 'Roboto', sans-serif;
                        font-weight: 500;
                        color: #262626;
                    }

                    i.atto-location-marker-lt {
                        position: absolute;
                        left: 8px;
                        top: 4px;
                        font-size: 16px;

                        &.clockedIn {
                            &:before {
                                color: #06B879
                            }
                        }

                        &.clockedOut {
                            &:before {
                                color: #E05656
                            }
                        }

                        &.onBreak {
                            &:before {
                                color: #FBA345
                            }
                        }

                        &.notActive {
                            &:before {
                                color: #999999
                            }
                        }

                        &.locationOff {
                            &:before {
                                color: #06B879
                            }
                        }
                    }

                    i.atto-no-location-pin {
                        position: absolute;
                        left: 8px;
                        top: 1px;
                        font-size: 16px;
                    }

                    p {
                        margin: 0;
                        font-size: 0.875rem;
                        line-height: 1.25rem;
                        font-family: 'Roboto', sans-serif;
                        max-width: 260px;
                        display: inline-flex;
                        align-items: center;

                        &.b {
                            font-weight: 500;
                        }

                        &.b.location-off {
                            font-weight: 500;
                            color: #E05656;

                            i {
                                margin-left: 10px;
                            }
                        }
                    }

                    &.column {
                        flex-direction: column;
                        margin-bottom: 0;
                        align-items: flex-start;
                    }

                    .clocked-in {
                        color: #262626;
                        margin-top: 16px;
                    }
                }
            }
        }

    }

    .leaflet-container {
        a.leaflet-popup-close-button {
            right: 20px;
            top: 20px;
            color: #efefef;
            font-size: 32px;
            margin: 0;
            padding: 0;
            height: 24px;
            font-family: "Roboto", sans-serif;
            font-weight: 300;
            line-height: 24px;
            width: 24px;
        }
    }

    .leaflet-popup-tip-container {
        width: 30px;
        height: 30px;
        margin-left: -15px;

        .leaflet-popup-tip {
            width: 20px;
            height: 20px;
            box-shadow: 0 -2px 10px 0 rgba(199, 199, 199, 0.5);
            color: transparent;
        }
    }

    .leaflet-div-icon {
        background: transparent;
        border: 0;
    }

    .inner-clockin {
        background-image: url('~@assets/images/green-marker.svg');
        background-repeat: no-repeat;
        -webkit-background-size: contain;
        background-size: contain;
        width: 60px;
        height: 60px;
        display: block;
    }

    .inner-clockout {
        background-image: url('~@assets/images/red-marker.svg');
        background-repeat: no-repeat;
        -webkit-background-size: contain;
        background-size: contain;
        width: 60px;
        height: 60px;
        display: block;
    }

    .inner-break {
        background-image: url('~@assets/images/orange-marker.svg');
        background-repeat: no-repeat;
        -webkit-background-size: contain;
        background-size: contain;
        width: 60px;
        height: 60px;
        display: block;
    }
</style>